import React, { useState, useEffect } from "react";
import { Form, Col, Row, Container } from "react-bootstrap";
import water_logo from "../../../images/water_logo_large.png";
import WellReportService from "../../../api-service/WellReportService";
import TesterInfo from "./TesterInfo";
import WellOwner from "./WellOwner";
import WellInfo from "./WellInfo";
import Confirmation from "./Confirmation";
import IrrigationInfo from "./IrrigationInfo";
import PumpRate from "./PumpRate";
import StatusBar from "./StatusBar";
import AdditionalInformation from "./AdditionalInformation";
import { ToastContainer, toast } from "react-toastify";
import Stepper from "./Stepper";
import { EMPTY, WELL_FORM_STEPS } from "../../../configurations/Constants";
import {
  ERROR_LOADING_WELL_IRRIG_UNIT_LIST,
  FORM_SAVED_LOCALLY,
  FORM_SUBMITTED_SUCCESSFULLY,
  NO_FORMS_SAVED_LOCALLY,
  STAFF_AUTHORIZED,
  YOU_ARE_OFFLINE,
} from "../../../configurations/MessageConstants";

function StaffWellForm() {
  const [formSubmittedToast, setFormSubmittedToast] = useState(false);
  const [formSavedToast, setFormSavedToast] = useState(false);
  const [noFormsSavedToast, setNoFormsSavedToast] = useState(false);
  const [step, setStep] = useState(0);
  const [irrigationCompany, setIrrigationCompany] = useState(null);
  const [dateTested, setDateTested] = useState(null);
  const [personCompletingTest, setPersonCompletingTest] = useState(EMPTY);
  const [license, setLicense] = useState(EMPTY);
  const [wellOwnerName, setWellOwnerName] = useState(EMPTY);
  const [phone, setPhone] = useState(EMPTY);
  const [address, setAddress] = useState(EMPTY);
  const [city, setCity] = useState(EMPTY);
  const [state, setState] = useState({ label: "Nebraska", value: "Nebraska" });
  const [zip, setZip] = useState(EMPTY);
  const [wellRegistration, setWellRegistration] = useState(null);
  const [irrigatedAcres, setIrrigatedAcres] = useState(EMPTY);
  const [fieldNickname, setFieldNickname] = useState(EMPTY);
  const [legalDescription, setLegalDescription] = useState(EMPTY);
  const [county, setCounty] = useState(null);
  const [pipeWallType, setPipeWallType] = useState(null);
  const [pipeWallThickness, setPipeWallThickness] = useState(EMPTY);
  const [lat, setLat] = useState(EMPTY);
  const [long, setLong] = useState(EMPTY);
  const [electricityProvider, setElectricityProvider] = useState(EMPTY);
  const [isElectricPowerUnit, setIsElectricPowerUnit] = useState(EMPTY);
  const [nonElectric, setNonElectric] = useState(EMPTY);
  const [otherNonElectric, setOtherNonElectric] = useState(EMPTY);
  const [hasHourMeter, setHasHourMeter] = useState(EMPTY);
  const [doesMeterWork, setDoesMeterWork] = useState(EMPTY);
  const [pivotIrrigationType, setPivotIrrigationType] = useState(EMPTY);
  const [Pivot, setPivot] = useState(EMPTY);
  const [floodIrrigationType, setFloodIrrigationType] = useState(EMPTY);
  const [Flood, setFlood] = useState(EMPTY);
  const [pivotFloodIrrigationType, setPivotFloodIrrigationType] =
    useState(EMPTY);
  const [PivotFlood, setPivotFlood] = useState(EMPTY);
  const [otherIrrigationType, setOtherIrrigationType] = useState(EMPTY);
  const [OtherIrrigation, setOtherIrrigation] = useState(EMPTY);
  const [otherIrrigationTypeName, setOtherIrrigationTypeName] = useState(EMPTY);
  const [endGun, setEndGun] = useState(EMPTY);
  const [swingArm, setSwingArm] = useState(EMPTY);
  const [endGunGpm, setEndGunGpm] = useState(EMPTY);
  const [pumpRateType, setPumpRateType] = useState(EMPTY);
  const [otherPumpRateType, setOtherPumpRateType] = useState(EMPTY);
  const [pumpRate, setPumpRate] = useState(EMPTY);
  const [notes, setNotes] = useState(EMPTY);
  const [allWellOptions, setAllWellOptions] = useState([]);

  const initialState = () => {
    setFormSubmittedToast(false);
    setFormSavedToast(false);
    setNoFormsSavedToast(false);
    setStep(0);
    setIrrigationCompany(null);
    setDateTested(null);
    setPersonCompletingTest(EMPTY);
    setLicense(EMPTY);
    setWellOwnerName(EMPTY);
    setPhone(EMPTY);
    setAddress(EMPTY);
    setCity(EMPTY);
    setState({ label: "Nebraska", value: "Nebraska" });
    setZip(EMPTY);
    setWellRegistration(null);
    setIrrigatedAcres(EMPTY);
    setFieldNickname(EMPTY);
    setLegalDescription(EMPTY);
    setCounty(null);
    setPipeWallType(null);
    setPipeWallThickness(EMPTY);
    setLat(EMPTY);
    setLong(EMPTY);
    setElectricityProvider(EMPTY);
    setIsElectricPowerUnit(EMPTY);
    setNonElectric(EMPTY);
    setOtherNonElectric(EMPTY);
    setHasHourMeter(EMPTY);
    setDoesMeterWork(EMPTY);
    setPivotIrrigationType(EMPTY);
    setPivot(EMPTY);
    setFloodIrrigationType(EMPTY);
    setFlood(EMPTY);
    setPivotFloodIrrigationType(EMPTY);
    setPivotFlood(EMPTY);
    setOtherIrrigationType(EMPTY);
    setOtherIrrigation(EMPTY);
    setOtherIrrigationTypeName(EMPTY);
    setEndGun(EMPTY);
    setSwingArm(EMPTY);
    setEndGunGpm(EMPTY);
    setPumpRateType(EMPTY);
    setOtherPumpRateType(EMPTY);
    setPumpRate(EMPTY);
    setNotes(EMPTY);
  };

  useEffect(() => {
    (async function () {
      if (document.getElementById("jsd-widget")) {
        document.getElementById("jsd-widget").style.opacity = "1";
      }
      await getWellAndIrrigsData();
    })();
  }, []);

  const getWellAndIrrigsData = async () => {
    let allWellsAndIrrigsData = {};
    try {
      let response = await WellReportService.getWellAndIrrigs();
      allWellsAndIrrigsData = response.data.data;
      generateWellArray(allWellsAndIrrigsData);
    } catch (error) {
      console.error(ERROR_LOADING_WELL_IRRIG_UNIT_LIST, error);
      return false;
    }
  };
  const generateWellArray = (wellsAndIrrigs) => {
    const WellsArray = wellsAndIrrigs.irrig_wells.map((value) => ({
      value,
      label: value,
    }));
    setAllWellOptions(WellsArray);
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    switch (name) {
      // tester info
      case "personCompletingTest":
        setPersonCompletingTest(value);
        break;
      case "license":
        setLicense(value);
        break;

      // well owner
      case "wellOwnerName":
        setWellOwnerName(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "address":
        setAddress(value);
        break;
      case "city":
        setCity(value);
        break;
      case "zip":
        setZip(value);
        break;

      //well info
      case "irrigatedAcres":
        setIrrigatedAcres(value);
        break;
      case "fieldNickname":
        setFieldNickname(value);
        break;
      case "legalDescription":
        setLegalDescription(value);
        break;
      case "pipeWallThickness":
        setPipeWallThickness(value);
        break;
      case "lat":
        setLat(value);
        break;
      case "long":
        setLong(value);
        break;

      // irrig info

      case "isElectricPowerUnit":
        setIsElectricPowerUnit(value);
        break;
      case "nonElectric":
        setNonElectric(value);
        break;
      case "otherNonElectric":
        setOtherNonElectric(value);
        break;
      case "hasHourMeter":
        setHasHourMeter(value);
        break;
      case "doesMeterWork":
        setDoesMeterWork(value);
        break;
      case "otherIrrigationTypeName":
        setOtherIrrigationTypeName(value);
        break;
      case "endGun":
        setEndGun(value);
        break;
      case "swingArm":
        setSwingArm(value);
        break;
      case "endGunGpm":
        setEndGunGpm(value);
        break;

      // pump rate
      case "pumpRateType":
        setPumpRateType(value);
        break;
      case "otherPumpRateType":
        setOtherPumpRateType(value);
        break;
      case "pumpRate":
        setPumpRate(value);
        break;

      // additional info
      case "notes":
        setNotes(value);
        break;

      default:
        break;
    }
  };

  const handleCheckboxChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let checked = event.target.checked;
    switch (name) {
      case "pivotIrrigationType": {
        setPivotIrrigationType(value);
        if (checked === true) {
          setPivotIrrigationType(value);
          setPivot(true);
        } else {
          setPivotIrrigationType(EMPTY);
          setPivot(false);
        }
        break;
      }
      case "floodIrrigationType": {
        setFloodIrrigationType(value);
        if (checked === true) {
          setFloodIrrigationType(value);
          setFlood(true);
        } else {
          setFloodIrrigationType(EMPTY);
          setFlood(false);
        }
        break;
      }
      case "pivotFloodIrrigationType": {
        setPivotFloodIrrigationType(value);
        if (checked === true) {
          setPivotFloodIrrigationType(value);
          setPivotFlood(true);
        } else {
          setPivotFloodIrrigationType(EMPTY);
          setPivotFlood(false);
        }
        break;
      }
      case "otherIrrigationType": {
        setOtherIrrigationType(value);
        if (checked === true) {
          setOtherIrrigationType(value);
          setOtherIrrigation(true);
        } else {
          setOtherIrrigationType(EMPTY);
          setOtherIrrigation(false);
        }
        break;
      }
      default:
        break;
    }
  };

  const handleDateChange = (date) => {
    setDateTested(date);
  };
  const handleStateChange = (stateValue) => {
    setState(stateValue);
  };
  const handleWellIdChange = (well) => {
    setWellRegistration(well);
  };
  const handleIrrigatedAcresChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === EMPTY || regex.test(e.target.value)) {
      setIrrigatedAcres(e.target.value);
    }
  };

  const handleCountyChange = (county) => {
    setCounty(county);
  };
  const handlePipeWallTypeChange = (type) => {
    setPipeWallType(type);
  };

  const handleElectricityProviderChange = (provider) => {
    setElectricityProvider(provider);
  };
  const handleIrrigatioCompanyChange = (company) => {
    setIrrigationCompany(company);
  };

  const FormSubmitted = (value) => {
    initialState();
    setFormSubmittedToast(value);
    toast.success(FORM_SUBMITTED_SUCCESSFULLY);
    setFormSubmittedToast(false);
  };

  const NoSavedFroms = (value) => {
    initialState();
    setNoFormsSavedToast(value);
    toast.success(NO_FORMS_SAVED_LOCALLY);
    setNoFormsSavedToast(false);
  };

  const FormSaved = (value) => {
    initialState();
    setStep(0);
    setFormSavedToast(value);
    toast.warn(
      <div>
        {YOU_ARE_OFFLINE}.
        <br />
        {FORM_SAVED_LOCALLY}
      </div>
    );
    setFormSavedToast(false);
  };

  const renderForm = (step, inputValues) => {
    switch (step) {
      case 1:
        return (
          <WellOwner
            nextStep={nextStep}
            prevStep={prevStep}
            handleChange={handleChange}
            inputValues={inputValues}
            handleStateChange={handleStateChange}
          />
        );
      case 2:
        return (
          <WellInfo
            nextStep={nextStep}
            prevStep={prevStep}
            handleChange={handleChange}
            handleIrrigatedAcresChange={handleIrrigatedAcresChange}
            handleWellIdChange={handleWellIdChange}
            handleCountyChange={handleCountyChange}
            handlePipeWallTypeChange={handlePipeWallTypeChange}
            inputValues={inputValues}
          />
        );
      case 3:
        return (
          <IrrigationInfo
            nextStep={nextStep}
            prevStep={prevStep}
            handleCheckboxChange={handleCheckboxChange}
            handleElectricityProviderChange={handleElectricityProviderChange}
            handleChange={handleChange}
            inputValues={inputValues}
          />
        );
      case 4:
        return (
          <PumpRate
            nextStep={nextStep}
            prevStep={prevStep}
            handleChange={handleChange}
            inputValues={inputValues}
          />
        );
      case 5:
        return (
          <AdditionalInformation
            nextStep={nextStep}
            prevStep={prevStep}
            handleChange={handleChange}
            inputValues={inputValues}
          />
        );
      case 6:
        return (
          <Confirmation
            nextStep={nextStep}
            prevStep={prevStep}
            inputValues={inputValues}
            FormSubmitted={(value) => FormSubmitted(value)}
            FormSaved={(value) => FormSaved(value)}
          />
        );
      default:
        return (
          <TesterInfo
            nextStep={nextStep}
            handleChange={handleChange}
            inputValues={inputValues}
            handleDateChange={handleDateChange}
            handleIrrigatioCompanyChange={handleIrrigatioCompanyChange}
          />
        );
    }
  };

  const inputValues = {
    irrigationCompany,
    dateTested,
    personCompletingTest,
    license,
    wellOwnerName,
    phone,
    address,
    city,
    state,
    zip,
    allWellOptions,
    wellRegistration,
    irrigatedAcres,
    fieldNickname,
    legalDescription,
    county,
    pipeWallType,
    pipeWallThickness,
    lat,
    long,
    electricityProvider,
    isElectricPowerUnit,
    nonElectric,
    otherNonElectric,
    hasHourMeter,
    doesMeterWork,
    pivotIrrigationType,
    Pivot,
    floodIrrigationType,
    Flood,
    pivotFloodIrrigationType,
    PivotFlood,
    otherIrrigationType,
    OtherIrrigation,
    otherIrrigationTypeName,
    endGun,
    swingArm,
    endGunGpm,
    pumpRateType,
    otherPumpRateType,
    pumpRate,
    notes,
  };
  return (
    <div className="well-test-form">
      {formSubmittedToast ||
        formSavedToast ||
        (noFormsSavedToast && (
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        ))}
      <div className="message-banner">
        <Container fluid>
          <Row>
            <Form.Group
              as={Col}
              md="3"
              style={{
                borderRight: "2px solid #ccc",
              }}
              className="pe-5 ps-5 mb-2 mt-4"
            >
              <img src={water_logo} className="img-fluid mw-100" alt="Logo" />
            </Form.Group>
            <Form.Group as={Col} className="ps-4 pe-4 mt-4 mb-2" md="6">
              <h2>Irrigation Well Flow Test Form</h2>
              <p className="text-muted">{STAFF_AUTHORIZED}</p>
            </Form.Group>
            <Form.Group
              as={Col}
              md="3"
              className="mt-3 mb-3 pe-5 ps-5 well-test-form-stats"
            >
              <StatusBar
                FormSubmitted={(value) => FormSubmitted(value)}
                NoSavedFroms={(value) => NoSavedFroms(value)}
              />
            </Form.Group>
          </Row>
        </Container>
      </div>
      {step < 6 && (
        <div className="well-test-form-stepper">
          <Stepper steps={WELL_FORM_STEPS} activeStep={step} />
        </div>
      )}
      {renderForm(step, inputValues)}
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default StaffWellForm;
